module.exports = __webpack_public_path__ + "img/sun-bright.5aab5a0e.svg";